module.exports = __webpack_public_path__ + "img/icon-archive-company-warning.fe3cb5ad.svg";